import React from "react";
import { SettingRow } from "../SettingRow";
import { Text } from "../../../../../../common/components/input/Text";
import { INFORMATIONAL_BANNER_ACCEPT_BUTTON_DEFAULT_TEXT } from "../../../../superorg/settings/ConsentBannerSettings";

interface ConsentBannerUSTextRowProps {
  formApi: { change: (field: string, value: string) => void };
}

export const ConsentBannerUSButtonRow = ({ formApi }: ConsentBannerUSTextRowProps) => {
  return (
    <SettingRow
      maxWidthChildren={true}
      title="Accept Button Text"
      helpText="This is the text that will be used for the button to dismiss the informational banner or the opt-out banner."
    >
      <Text
        className="w-100 mb-sm"
        fullWidth={false}
        field="informationalBannerAcceptButtonText"
        variant="outlined"
        helperText=""
        required
        inputProps={{ maxLength: 48 }}
      />
      <div>
        <a
          onClick={(e) => {
            e.preventDefault();
            formApi.change(
              "informationalBannerAcceptButtonText",
              INFORMATIONAL_BANNER_ACCEPT_BUTTON_DEFAULT_TEXT,
            );
          }}
          href="#"
        >
          Set to Default Text
        </a>
      </div>
    </SettingRow>
  );
};
